
define( 'FORCES_AND_MOTION_BASICS/../nls/sv/forces-and-motion-basics-strings',{
          "none": "Ingen",
          "force": "Kraft",
          "values": "Värden",
          "frictionTitle": "Friktion",
          "redWins": "Röd vinner!",
          "frictionForce": "Friktionskraft",
          "pause": "Paus",
          "friction": "Friktion",
          "forces-and-motion-basics.name": "Kraft och rörelse: Grunder",
          "appliedForce": "Pålagd kraft",
          "leftForce": "Vänstra kraften",
          "rightForce": "Högra kraften",
          "sound": "Ljud",
          "lots": "Mycket",
          "forces": "Krafter",
          "motion": "Rörelse",
          "tugOfWar": "Dragkamp",
          "go": "Kör!",
          "newtons.n": "Newton (N)",
          "sumOfForcesEqualsZero": "Summa av krafter = 0",
          "blueWins": "Blå vinner!",
          "speed": "Fart",
          "sumOfForces": "Summa av krafter",
          "return": "Återställ",
          "translation.credits": "Anders Gölstam",
          "newtons": "Newton",
          "masses": "Massor"
        } );